console.log('top');

$(window).on('load', function () {
	setTimeout(function () {
		$('.lTxt').addClass('show');
		$('.sTxt').addClass('show');
		$('.mv_cover_img').addClass('show');
	}, 0);
	setTimeout(function () {
		$('.mv_text_box').addClass('show');
	}, 1000);
	// setTimeout(function () {
	// 	$('.merit').addClass('show');
	// }, 1000);
	// setTimeout(function () {
	// 	$('.line').addClass('show');
	// }, 2000);
});

let fadeInTarget = document.querySelectorAll('.merit, .line');
window.addEventListener('scroll', () => {
	for (let i = 0; i < fadeInTarget.length; i++) {
		const rect = fadeInTarget[i].getBoundingClientRect().top;
		const scroll = window.scrollY || document.documentElement.scrollTop;
		const offset = rect + scroll;
		const windowHeight = window.innerHeight; // 現在のブラウザの高さ
		if (scroll > offset - windowHeight + 100) {
			fadeInTarget[i].classList.add('show');
		} else {
			fadeInTarget[i].classList.remove('show');
		}
	}
});